function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuKebabVerticalBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu_kebab_vertical") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3864",
    width: 24,
    height: 24,
    rx: 12,
    style: {
      fill: "#f5f6fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20a2 2 0 1 1 1.413-.587A1.925 1.925 0 0 1 12 20zm0-6a2 2 0 0 1-1.412-3.413 2 2 0 1 1 2.825 2.825A1.927 1.927 0 0 1 12 14zm0-6a2.008 2.008 0 0 1-2-2 2 2 0 0 1 3.413-1.412 1.992 1.992 0 0 1 0 2.824A1.927 1.927 0 0 1 12 8z",
    style: {
      fill: "#758091"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuKebabVerticalBackground);
export default __webpack_public_path__ + "static/media/menu_kebab_vertical_background.a1f51e15dc4ed3160775ecd0db848fef.svg";
export { ForwardRef as ReactComponent };